import { create } from 'zustand'

import { get as apiGet } from '@/api/request'

interface PriceStore {
  btcPrice: number
  isLoading: boolean
  _initialized: boolean
  fetch: () => Promise<void>
  reset: () => void
}

export const usePriceStore = create<PriceStore>((set, get) => ({
  btcPrice: 0,
  isLoading: false,
  _initialized: false,

  async fetch() {
    if (!get()._initialized) {
      set({ isLoading: true })
    }
    try {
      const res = await apiGet<{ price: number }>('/price/btc')
      if (res.data?.data) {
        set({ btcPrice: res.data.data.price })
      }
    } catch {
      /* non-critical */
    } finally {
      set({ isLoading: false, _initialized: true })
    }
  },

  reset() {
    set({ btcPrice: 0, isLoading: false, _initialized: false })
  },
}))
